import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const voyageAi = defineConnector({
  identifier: "voyageAi",
  name: "Voyage AI",
  tagLine: "Embeddings and rerankers",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.voyageai\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Voyage AI dashboard](https://dashboard.voyageai.com/) and create an API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.voyageai.com/v1/embeddings",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        input: ["connection test"],
        model: "voyage-4-lite",
      }),
    }),
  },
});
